module.exports = __webpack_public_path__ + "static/media/premium-hi.4960f299.jpg";